module.exports = __webpack_public_path__ + "img/hoverbg.d5f3ccc3.png";